<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        row-key="id"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @expand-change="expandChange"
        @search-reset="searchClear"
        @row-save="handleSave"
        @toggleRowExpansion='expandRow(row)'
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            plain
            @click="downloadExceltest(scope.row)"
          >下载Excel</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <div style="display: flex;justify-content: center;">
            <el-button
              type="primary"
              size="small"
              v-if="tableOption.expandRowKeys[0]==scope.row.id"
              plain
              @click.stop="handleExpend(scope.row,'收起')"
            >收起</el-button>
            <el-button
              type="primary"
              size="small"
              v-else
              plain
              @click.stop="handleExpend(scope.row,'展开')"
            >展开</el-button>

          </div>
        </template>
        <template
          slot-scope="props"
          slot="expand"
        >
          <div>
            <!-- {{props.row.childList}} -->
            <el-table
              :data="props.row.vices"
              border
              style="margin-left:100px;width: 90%;"
              size="mini"
            >
              <el-table-column
                property="remindTime"
                label="历史提醒时间"
                align="center"
                :formatter="formatterRemindTime"
              >
              </el-table-column>
              <el-table-column
                property="peopleType"
                label="提醒人类型"
                min-width="150"
                align="center"
                :formatter="formatterPeopleType"
              >
                <!-- <template slot-scope="scope">
                  <div>
                    <div v-if='scope.row.isEdit'>
                      <el-select
                        v-model="scope.row.peopleType"
                        disabled
                        placeholder="请选择工程进度"
                      >
                        <el-option
                          v-for="item2 in peopleTypes"
                          :key="item2.value"
                          :label="item2.label"
                          :value="item2.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div v-else>
                      <el-select
                        v-model="scope.row.peopleType"
                        placeholder="请选择工程进度"
                      >
                        <el-option
                          v-for="item2 in peopleTypes"
                          :key="item2.value"
                          :label="item2.label"
                          :value="item2.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </template> -->
              </el-table-column>
              <el-table-column
                property="formWorkName"
                label="模板名称"
                align="center"
                :formatter="formatterFormWorkName"
              ></el-table-column>
              <el-table-column
                property="sendTime"
                label="发送时间"
                align="center"
                width="200"
                :formatter="formatterSendTime"
              >
              </el-table-column>
              <el-table-column
                property="remindPeople"
                label="提醒人"
                width="200"
                style="white-space:pre"
                align="center"
                :formatter="formatterRemindPeople"
              >
              </el-table-column>
              <el-table-column
                property="sendPeople"
                label="处理人"
                width="200"
                align="center"
                :formatter="formatterSendPeople"
              >
              </el-table-column>
              <el-table-column
                property="asd"
                label="操作"
                width="200"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="small"
                    plain
                    v-if="scope.row.remindStatus == 'NORMAL' "
                    @click.stop="openDialog(scope.row,scope.index)"
                  >提醒</el-button>
                  <el-button
                    size="small"
                    plain
                    v-if="scope.row.remindStatus == 'NORMAL' "
                    @click.stop="passAudit(scope.row,scope.$index)"
                  >关闭</el-button>
                  <div v-if="scope.row.remindStatus == 'REMINDED' ">
                    已提醒
                  </div>
                  <div v-if="scope.row.remindStatus == 'CLOSED' ">
                    已关闭
                  </div>
                </template>
              </el-table-column>
              <!--   <el-table-column
                property="endTime"
                label="工程结束时间"
                :formatter="formatterEndTime"
                align="center"
              >
              </el-table-column>
              <el-table-column
                property="realEndTime"
                label="工程实际结束时间"
                :formatter="formatterEndTime"
                align="center"
              >
              </el-table-column>
              <el-table-column
                property="totalMoney"
                label="服务费用"
                align="center"
              ></el-table-column>

              <el-table-column
                property="status"
                label="服务状态"
                :formatter="transStatusName"
                align="center"
              >
              </el-table-column>
              <el-table-column
                property="option"
                label="操作"
                align="center"
              >
                <template slot-scope="scope">
                  <template v-for="dsrmsButton in dsrmsButtons">
                    <div :key="dsrmsButton.id">
                      <el-button
                        type="default"
                        icon="el-icon-check"
                        size="small"
                        plain
                        v-if="handleDsrms(scope.row, dsrmsButton)"
                        @click.stop="statusOption(dsrmsButton.step, scope.row)"
                      >{{ dsrmsButton.name }}</el-button>
                    </div>
                  </template>
                  <el-button
                    type="success"
                    icon="el-icon-view"
                    size="small"
                    plain
                    @click.stop="openOptionHistory(scope.row)"
                  >操作历史</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
        </template>
      </avue-crud>
      <el-dialog
        title="提醒"
        :visible.sync="dialogFormVisible"
      >
        <el-form :model="form">
          <el-form-item
            label="提醒人类型"
            label-width="120px"
          >
            <div style='float:left;'>
              <el-select
                v-model="form.peopleType"
                placeholder="请选择提醒人类型"
                @change="choosePeopleType(form)"
              >
                <el-option
                  v-for="item2 in peopleTypes"
                  :key="item2.value"
                  :label="item2.label"
                  :value="item2.value"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            label="提醒人"
            label-width="120px"
          >
            <div>
              <div style='float:left;'>
                <el-select
                  v-model="remindPeople"
                  placeholder="请选择提醒人"
                  v-if="form.peopleType=='JOINS_USER'"
                  filterable
                  remote
                  :remote-method="remoteMethod"
                >
                  <el-option
                    v-for="item2 in multreminders"
                    :key="item2.id"
                    :label="item2.realName"
                    :value="item2.id"
                  ></el-option>
                </el-select>
              </div>
              <div style='float:left;'>
                <el-select
                  v-model="remindEmployeePeople"
                  placeholder="请选择提醒人"
                  filterable
                  multiple
                  v-if="form.peopleType == 'JOINS_EMPLOYEE'"
                  remote
                  :remote-method="remoteMethod"
                  value-key="id"
                >
                  <el-option
                    v-for="item2 in multreminders"
                    :key="item2.id"
                    :label="item2.realName"
                    :value="item2.id"
                  ></el-option>
                </el-select>
              </div>
              <div style='float:left;'>
                <el-select
                  v-model="remindEngineerPeople"
                  placeholder="请选择提醒人"
                  filterable
                  multiple
                  remote
                  v-if=" form.peopleType=='JOINS_ENGINEER'"
                  :remote-method="remoteMethod"
                  value-key="id"
                >
                  <el-option
                    v-for="item2 in multreminders"
                    :key="item2.id"
                    :label="item2.realName"
                    :value="item2.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            label="模板名称"
            label-width="120px"
          >
            <div style='float:left;'>
              <el-select
                v-model="form.templateCode"
                placeholder="请选择模板名称"
              >
                <el-option
                  v-for="item2 in moduleTypeList"
                  :key="item2.templateCode"
                  :label="item2.templateName"
                  :value="item2.templateCode"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="remindhandle"
          >确 定</el-button>
        </div>
      </el-dialog>

    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  findByLabel,
  formatterDateToUTC,
  getStatusName,
  parseStatus
} from "@/util/util";
import { DIC } from "@/const/dic";
import { resolveUrlPath, setUrlPath } from "@/util/util";
import { messageTipOption } from "@/const/salesCloud/messageTipOption";
import {
  findEngineeringOrderList,
  changeStatus,
  closeStatus,
  findTemplateV2,
  downloadExcelV2,
  findUsersAll,
  findStuff
} from "@/api/salesCloud/messageTip";
import { findBalance, addBalance } from "@/api/salesCloud/accountBalance";
import { findUserList } from "@/api/salesCloud/bindEngineer";
import { Image } from "element-ui";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
export default {
  name: "messageTip",
  data() {
    return {
      tableOption: messageTipOption, //表格设置属性
      tableData: [], //表格的数据
      peopleTypes: DIC.CUSTOMER_USER_TYPE,
      currpeopleType: "",
      form: {},
      remindEngineerPeople: [],
      remindPeople: "",
      remindEmployeePeople: [],
      currRow: {},
      moduleTypeList: [],
      reminders: [],
      multreminders: [],
      dialogFormVisible: false,
      rechargeDialog: false,
      rechargeMoney: "",
      payRadio: "OFFLINE_REMIT",
      remittanceAccountName: "",
      remittanceAccount: "",
      currBank: "",
      remittanceBank: DIC.BANK_LIST,
      fileList1: [],
      remittanceImgs: [],
      QRCodeDialog: false,
      config: {},
      evaluateDialog: false,
      dialogBalancePay: false,
      noMoney: true,
      //余额支付
      balancePayRadio: "YE",
      tablePage: 1,
      tableLoading: false,
      loading: false,
      classifySelects: [],
      currClassify: [],
      tabelObj: {},
      url:
        "http://joinstech-public.oss-cn-shenzhen.aliyuncs.com/7de80e574b428d8e6bc68663e33e1f60,https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      list: [],
      ids: "",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      }
    };
  },
  created() {
    let params = {};
    params.moduleType = "CUSTOMER";
    findTemplateV2(params).then(res => {
      let data = JSON.parse(res.data);
      this.moduleTypeList = data;
      console.log(data);
    });
    this.tableOption.expandRowKeys = [];
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    remoteMethod(query) {
      console.log(query);
      if (query.length == 5) {
        this.multreminders = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query
          };
          findUserList(params).then(res => {
            console.log(res);
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              this.multreminders = data;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        }, 200);
      } else if (query.length == 11) {
        // this.loading = true;
        this.multreminders = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query
          };
          findUserList(params).then(res => {
            console.log(res);
            let data = JSON.parse(res.data);
            this.multreminders = data;
          });
        }, 200);
      } else {
        this.classifySelects = [];
      }
    },
    choosePeopleType(e) {
      console.log(e);
      console.log(this.form);
      this.multreminders = [];
      // this.form = {};
      this.currpeopleType = "";
      if (e.peopleType == "JOINS_USER") {
        this.currpeopleType = e.peopleType;
        this.remindEmployeePeople = [];
        this.remindEngineerPeople = [];
      } else if (e.peopleType == "JOINS_ENGINEER") {
        this.currpeopleType = e.peopleType;
        this.remindPeople = "";
        this.remindEmployeePeople = [];
      } else if (e.peopleType == "JOINS_EMPLOYEE") {
        this.currpeopleType = e.peopleType;
        this.remindPeople = "";
        this.remindEngineerPeople = [];
      }
      // else {
      //   e.remindPeople = [];
      // }
    },
    openDialog(row, index) {
      this.form = {};
      console.log(row, index);
      this.currRow = row;
      this.dialogFormVisible = true;
    },
    remindhandle() {
      console.log(this.form);
      console.log(this.currRow);
      let params = this.form;
      if (this.form.peopleType == "JOINS_ENGINEER") {
        params.remindPeople = this.remindEngineerPeople.join(",");
      }
      if (this.form.peopleType == "JOINS_EMPLOYEE") {
        params.remindPeople = this.remindEmployeePeople.join(",");
      }
      if (this.form.peopleType == "JOINS_USER") {
        params.remindPeople = this.remindPeople;
      }
      params.id = this.currRow.id;
      params.status = "REMINDED";
      changeStatus(this.form).then(res => {
        console.log(res);
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "提醒成功",
            type: "success"
          });
          this.handleList();
          this.dialogFormVisible = false;
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          this.dialogFormVisible = false;
        }
      });
    },
    destroyThisPay() {
      this.QRCodeDialog = false;
      this.rechargeDialog = false;
      this.payMoneyDialog = false;
      this.dialogBalancePay = false;
    },
    formatterRemindTime(row) {
      if (null != row.remindTime) {
        return formatterDateToUTC(row.remindTime);
      }
    },
    formatterPeopleType(row) {
      if (null != row.peopleType) {
        row.peopleType;
        let types = row.peopleType.split(",");
        let arr = [];
        for (let i of types) {
          let str = parseStatus(DIC.CUSTOMER_USER_TYPE, i);
          arr.push(str);
        }
        return arr.join(",");
      } else {
        return "-";
      }
    },
    rechargeWayBALANCE() {
      this.paymentTask.rechargeWay = "BALANCE";
    },
    rechargeWayWX_PAY() {
      this.paymentTask.rechargeWay = "WX_PAY";
    },
    rechargeWayOFFLINE_REMIT() {
      this.paymentTask.rechargeWay = "OFFLINE_REMIT";
    },
    toPayMoney() {
      console.log("充值");
      this.clean();
      this.rechargeDialog = true;
    },
    listPay() {
      if (this.balancePayRadio == "WX") {
        this.immediatePayment(this.payRow);
      } else {
        let obj = {};
        obj.id = this.payRow.id;
        balancePay(obj).then(res => {
          console.log(res);
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "支付成功",
              type: "success"
            });
            setTimeout(() => {
              this.handleList();
              console.log("延迟2s");
            }, 2000);
            this.dialogBalancePay = false;
          } else {
            this.$message({
              showClose: true,
              message: "余额不足",
              type: "error"
            });
            this.handleList();
            this.dialogBalancePay = false;
          }
        });
      }
    },
    expandRow(row) {
      console.log(row);
    },
    handleSingleSave(index, row) {
      console.log(row, index);
      row.isEdit = !row.isEdit;
      let params = { startTime: row.serviceTime, endTime: row.endTime };
      editEngineeringOrder(row.id, params).then(res => {
        console.log(res);
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    openPay(row) {
      console.log(row);
      this.payRow = row;
      findBalance().then(res => {
        let data = JSON.parse(res.data);
        this.getBalance = data.rows[0].balance;
        let wxPay = row.payMoney;
        // let wxPay = 1111111;
        console.log(wxPay, this.getBalance);
        this.noMoney = wxPay > this.getBalance;
        this.dialogBalancePay = true;
      });
    },
    passAudit(row, index) {
      console.log(row, index);
      this.$confirm(`是否确认关闭?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.currRow = row;
        let params = this.form;
        params.id = this.currRow.id;
        params.status = "CLOSED";
        closeStatus(this.form).then(res => {
          console.log(res);
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "关闭成功",
              type: "success"
            });
            this.handleList();
            this.dialogFormVisible = false;
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
          }
        });
      });
    },
    rejectAudit(row, index) {
      this.$prompt("请输入拒绝原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,255}$/,
        inputErrorMessage: "请输入正确长度的备注信息1-255"
      })
        .then(({ value }) => {
          let obj = {};
          obj.id = row.id;
          obj.refusedReason = value;
          refusedAudit(obj).then(response => {
            if (response.code == "200") {
              this.$message({
                showClose: true,
                message: "操作成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: "提交出错",
            type: "error"
          });
        });
    },
    handleExpandEdit(index, row) {
      // row.isEdit = !row.isEdit;
    },
    handleExpend(row, index) {
      console.log(row, index);
      row.isExpend = !row.isExpend;
      if (index == "展开") {
        if (this.tableOption.expandRowKeys) {
          this.tableOption.expandRowKeys = [];
          this.tableOption.expandRowKeys.push(row.id);
        }
      } else {
        this.tableOption.expandRowKeys = [];
      }
    },
    expandChange(row, expendList) {
      console.log(row, expendList);
      if (expendList.length) {
        this.tableOption.expandRowKeys = [];
        if (row) {
          this.tableOption.expandRowKeys.push(row.id);
        }
      } else {
        this.tableOption.expandRowKeys = [];
      }
    },
    formatterFormWorkName(row) {
      if (null != row.formWorkName) {
        return row.formWorkName;
      } else {
        return "-";
      }
    },
    formatterRemindPeople(row) {
      if (null != row.remindPeople) {
        return row.remindPeople.replace(/,/g, "\r");
      } else {
        return "-";
      }
    },
    formatterSendPeople(row) {
      if (null != row.sendPeople) {
        return row.sendPeople;
      } else {
        return "-";
      }
    },
    formatterSendTime(row) {
      if (null != row.sendTime) {
        return formatterDateToUTC(row.sendTime);
      } else {
        return "-";
      }
    },
    formatterActualEndTime(row) {
      // console.log(row);
      if (null != row.actualEndTime) {
        return formatterDateToUTC(row.actualEndTime);
      }
    },
    formatterPayMoney(row) {
      if (null != row.payMoney) {
        return row.payMoney;
      } else {
        return "-";
      }
    },
    formatterPayStatus(row) {
      // console.log(row);
      return row.payStatus == "WAIT_PAY"
        ? "待支付"
        : row.payStatus == "WAIT_AUDIT"
        ? "待审核"
        : "已完成";
    },
    transStatusName(row) {
      return getStatusName(this.steppings, row.status);
    },
    clean() {
      this.currClassify = "";
      this.classifySelects = [];
    },
    searchClear() {
      this.currClassify = "";
    },
    choseClassifyItem() {
      console.log(this.currClassify);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      console.log(this.page);
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      findEngineeringOrderList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        for (let i of data.rows) {
          for (let j of i.vices) {
            j.isEdit = true;
            j.isExpend = true;
            // j.endTime = j.endTime + "";
            // j.serviceTime = j.serviceTime + "";
          }
        }
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findEngineeringOrderList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        for (let i of data.rows) {
          for (let j of i.vices) {
            j.isEdit = true;
            j.isExpend = true;
            // j.endTime = j.endTime + "";
            // j.serviceTime = j.serviceTime + "";
          }
        }
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.serviceTimeStart = params.startDate_endDate[0];
        params.serviceTimeEnd = params.startDate_endDate[1];
      } else {
        params.serviceTimeStart = "";
        params.serviceTimeEnd = "";
      }
      if (
        null != params.startDate_endDate1 &&
        undefined != params.startDate_endDate1 &&
        "" != params.startDate_endDate1
      ) {
        params.remindTimeStart = params.startDate_endDate1[0];
        params.remindTimeEnd = params.startDate_endDate1[1];
      } else {
        params.remindTimeStart = "";
        params.remindTimeEnd = "";
      }
      console.log(params);
      findEngineeringOrderList(params).then(res => {
        if (res.code != 500) {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          for (let i of data.rows) {
            for (let j of i.vices) {
              j.isEdit = true;
              j.isExpend = true;
              // j.endTime = j.endTime + "";
              // j.serviceTime = j.serviceTime + "";
            }
          }
          this.page = {
            total: data.total,
            currentPage: params.page,
            pageSize: params.size
          };
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.tableData = [];
          console.log(11);
        }
      });
    },
    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      findEngineeringOrderList(params).then(res => {
        let data = JSON.parse(res.data);
        for (let i of data.rows) {
          for (let j of i.vices) {
            j.isEdit = true;
            j.isExpend = true;
            // j.endTime = j.endTime + "";
            // j.serviceTime = j.serviceTime + "";
          }
        }
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      // this.clean();
      // this.$refs.crud.rowAdd();
      let obj = {
        label: "新增工程服务",
        value: "messageTip/add"
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label)
      });
    },
    handleEdit(row, index) {
      console.log(row, index);
      let obj = {
        label: "编辑工程服务",
        value: "messageTip/edit",
        query: { id: row.id, aname: row.name }
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query
      });
    },
    handleView(row, index) {
      console.log(row, index);
      let obj = {
        label: "查看工程服务",
        value: "messageTip/view",
        query: { id: row.id, aname: row.name }
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query
      });
    },
    downloadExceltest() {
      let params = {};
      downloadExcelV2(params).then(res => {
        console.log(res.data);
        window.open(res.data);
      });
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;
      findEngineeringOrderList(params).then(res => {
        let data = JSON.parse(res.data);
        for (let i of data.rows) {
          for (let j of i.vices) {
            j.isEdit = true;
            j.isExpend = true;
            // j.endTime = j.endTime + "";
            // j.serviceTime = j.serviceTime + "";
          }
        }
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      console.log(row);
      addTags(row).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      let ids = val.map(item => {
        return item.id;
      });
      this.ids = ids.join(",");
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    balancePayment() {
      let params = {};
      params.money = this.rechargeMoney;
      params.rechargeType = "BALANCE";
      params.payType = this.payRadio;
      params.openingUser = this.remittanceAccountName;
      params.bankNumber = this.remittanceAccount;
      params.bankName = this.currBank;
      params.url = this.remittanceImgs + "";
      if (params.payType == "OFFLINE_REMIT") {
        if (
          params.money &&
          params.openingUser &&
          params.bankNumber &&
          params.bankName &&
          params.url
        ) {
          addBalance(params).then(res => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message:
                  "非常感谢您对慧家平台的信任，请耐心等待平台财务人员核实。",
                type: "success"
              });
              this.rechargeDialog = false;
              this.payMoneyDialog = false;
              this.dialogBalancePay = false;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请完善输入信息",
            type: "error"
          });
        }
      } else {
        addBalance(params).then(response => {
          this.tableLoading = false;
          if (response.code == "200") {
            let data = response.data;
            let count = 0;
            wxNativePayQuery(data.outTradeNo).then(res => {
              if (res.code == "200") {
                if (res.data == "SUCCESS") {
                  let _this = this;
                  setTimeout(function() {
                    _this.QRCodeDialog = false;
                    _this.$message({
                      showClose: true,
                      message: "充值成功",
                      type: "success"
                    });
                    _this.handleList();
                    _this.payMoneyDialog = false;
                    _this.rechargeDialog = false;
                    _this.dialogBalancePay = false;
                  }, 1000);
                } else {
                  count++;
                  if (count < 3) {
                    wxNativePayQuery(data.outTradeNo).then(res => {
                      if (res.code == "200") {
                        if (res.data == "SUCCESS") {
                          let _this = this;
                          setTimeout(function() {
                            _this.QRCodeDialog = false;
                            _this.$message({
                              showClose: true,
                              message: "充值成功",
                              type: "success"
                            });
                            _this.handleList();
                            _this.payMoneyDialog = false;
                            _this.rechargeDialog = false;
                            _this.dialogBalancePay = false;
                          }, 1000);
                        } else {
                          this.QRCodeDialog = false;
                          this.rechargeDialog = false;
                          this.dialogBalancePay = false;
                          this.$message({
                            showClose: true,
                            message: "支付超时",
                            type: "error"
                          });
                        }
                      } else {
                        this.QRCodeDialog = false;
                        this.rechargeDialog = false;
                        this.dialogBalancePay = false;
                        this.$message({
                          showClose: true,
                          message: "支付超时",
                          type: "error"
                        });
                      }
                    });
                  }
                }
                //this.handleList();
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付失败",
                  type: "error"
                });
                this.handleList();
              }
            });
            let start = new Date().getTime();
            while (true) if (new Date().getTime() - start > 1) break;
            this.config.value = "";
            this.config.value = data.codeUrl;
            this.QRCodeDialog = true;
          } else {
            this.$message({
              showClose: true,
              message: "支付失败",
              type: "error"
            });
            //???下面的感觉没用
            // this.$refs.crud.rowAdd();
            return;
          }
          // let data = JSON.parse(res.data);
        });
      }
    },
    async fnUploadremittanceImgs(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList1 = files;
            let array = results.res.requestUrls[0].split("?");
            this.remittanceImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(row.id);
      editTags(row).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "编辑成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    }
  }
};
</script>

    <style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
